var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.color,"icon":_vm.$_isIcon,"text":""}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c(_vm.$_icon.component,_vm._b({tag:"component"},'component',_vm.$_icon.bind,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }